import React from "react";
import OneWayBaseLogo from "../../assets/icons/onewaybase-logo.component";
import onewaybaseImage from "../../assets/images/onewaybase.png";

const handleRedirectToIRadar = () =>
  window.open("https://link2settle.com/", "_blank");

const LearnMore = () => (
  <div className="col-xl-6 col-lg-6 col-md-6 left order-2 order-md-1 order-lg-1 order-xl-1 d-flex justify-content-center align-items-center">
    <div className="box">
      <span className="brand">
        <OneWayBaseLogo bold size="3rem" />
      </span>
      <article style={{ height: "auto" }}>
        <h2>Welcome to OnewayBase</h2>
        <h3>A secure CRM built for charities and social-impact organizations</h3>
        <img
          src={onewaybaseImage}
          alt="OnewayBase"
          style={{ maxWidth: "100%", height: "auto", marginTop: "24px" }}
        />
      </article>
      <button
        className="btn btn-blue btn-small"
        onClick={handleRedirectToIRadar}
      >
        LEARN MORE
      </button>
      <p>OnewayBase © Copyright {new Date().getFullYear()}. All Rights Reserved.</p>
    </div>
  </div>
);

export default LearnMore;
